import { useState } from "react";
import { Utensils, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const ShareMealsToggle = ({ en, value, onChange, hasShare }) => {
  const [saving, setSaving] = useState(false);

  const toggle = async (next) => {
    onChange(next);
    if (!hasShare) return;
    setSaving(true);
    try {
      await api.patch("/share/progress/meals", { include_meals: next });
      toast.success(next
        ? (en ? "Meals are now visible to your coach" : "الوجبات مرئية للكوتش الآن")
        : (en ? "Meals are hidden from your coach" : "تم إخفاء الوجبات عن الكوتش"));
    } catch {
      toast.error(en ? "Couldn't save the change" : "تعذّر حفظ التغيير");
      onChange(!next);
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-neutral-50 rounded-2xl p-3 border-[1.5px] border-neutral-100">
      <label className="flex items-center justify-between gap-2 cursor-pointer">
        <div className="flex items-center gap-2 min-w-0">
          <Utensils className={`w-4 h-4 flex-shrink-0 ${value ? "text-brand-500" : "text-neutral-400"}`} />
          <div className="min-w-0">
            <div className="text-sm font-bold text-neutral-800">{en ? "Share daily meals" : "مشاركة الوجبات اليومية"}</div>
            <div className="text-[10px] text-neutral-500">
              {en ? "Every meal you log with calories & macros — read-only" : "كل وجبة تسجّلها بالسعرات والماكروز — للاطلاع فقط"}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {saving ? <Loader2 className="w-4 h-4 animate-spin text-brand-500" /> : (
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${value ? "bg-orange-100 text-brand-700" : "bg-neutral-200 text-neutral-600"}`} data-testid="share-meals-status-pill">
              {value ? (en ? "Visible to coach" : "مرئي للكوتش") : (en ? "Hidden" : "مخفي")}
            </span>
          )}
          <input type="checkbox" checked={value} onChange={(e) => toggle(e.target.checked)} disabled={saving}
            className="w-5 h-5 accent-orange-500" data-testid="share-include-meals-toggle" />
        </div>
      </label>
    </div>
  );
};
